import React, { useState } from "react";
import { Button } from "../Button";
import { DropdownOptions } from "../dropdownOptions";
import { useDispatch } from "react-redux";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../../Redux/Slices/alert.slice";
import { SOMETHING_WENT_WRONG } from "../../Constants/messages";
import { useAddSubject } from "../../hooks/subjectHooks/subject.hooks";
import { SubjectForm } from "./SubjectForm";
import { validateSubjectForm } from "./validateSubjectForm";
import { getValue } from "../../utils/object.utils";

export const AddSubject = () => {
  const dispatch = useDispatch();

  const [subjectName, setSubjectName] = useState("");
  const [selectedClasses, setSelectedClasses] = useState(
    [] as DropdownOptions[]
  );
  const [classMarks, setClassMarks] = useState<Record<string, number | string>>(
    {}
  );

  const [selectedSubjectTypeOption, setSelectedSubjectTypeOption] =
    useState<DropdownOptions | null>(null);

  const { isLoading: isAddingSubject, mutate: addSubject } = useAddSubject({
    onSuccess: () => {
      dispatch(setSuccessMessage("Subject added successfully."));
      setSubjectName("");
      setSelectedSubjectTypeOption(null);
      setSelectedClasses([]);
      setClassMarks({});
    },
    onError: (error: any) => {
      dispatch(
        setErrorMessage(error.response.data.message || SOMETHING_WENT_WRONG)
      );
    },
  });

  const onClassSelected = (options: DropdownOptions[]) => {
    setSelectedClasses(options);

    setClassMarks((prev) => {
      const next: Record<string, number | string> = {};
      options.forEach((option) => {
        const classId = String(getValue(option, "value", ""));
        next[classId] = prev[classId] ?? "";
      });
      return next;
    });
  };

  const onClassMarksChange = (
    classId: string | number,
    marks: number | string
  ) => {
    setClassMarks((prev) => ({
      ...prev,
      [String(classId)]: marks,
    }));
  };

  const onAddClass = () => {
    const classDetails = selectedClasses
      .map((classItem) => {
        const classId = getValue(classItem, "value");
        const marks = classMarks[String(classId)];
        return {
          class_id: Number(classId),
          subject_marks:
            marks === "" || marks === undefined || marks === null
              ? null
              : Number(marks),
        };
      })
      .filter(({ class_id }) => Boolean(class_id));

    const errorMessage = validateSubjectForm({
      name: subjectName,
      subject_type: selectedSubjectTypeOption?.value as string,
      classDetails,
    });

    if (errorMessage) {
      return dispatch(setErrorMessage(errorMessage));
    }

    addSubject({
      name: subjectName,
      subject_type: selectedSubjectTypeOption?.value as string,
      classDetails,
    });
  };

  return (
    <div className="flex flex-col">
      <SubjectForm
        subjectName={subjectName}
        onSubjectNameChange={setSubjectName}
        subjectType={selectedSubjectTypeOption}
        onSubjectTypeChange={setSelectedSubjectTypeOption}
        selectedClass={selectedClasses}
        onClassChange={onClassSelected}
        classMarks={classMarks}
        onClassMarksChange={onClassMarksChange}
      />
      <div>
        <Button
          loading={isAddingSubject}
          text="Save"
          onClick={() => {
            onAddClass();
          }}
        />
      </div>
    </div>
  );
};
